// extracted by mini-css-extract-plugin
export default {"paymentMethodInfo":"payment-method_paymentMethodInfo__iyOwP","numberAndDate":"payment-method_numberAndDate__cMhD0","brand":"payment-method_brand__CYLSe"};